
import { getLModelFile, getLModelFileDel } from "@/api/api-basic";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import addFile from "./components/add-file.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-add-file": addFile
  }
})
export default class PiSIMManage extends Vue {
  private formInline: objAny = {
    entSubUser: true,
    globalOrder: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: "",
    logined: true
  };

  private privilegeVoObj: objAny = {};
  private fileStatusColor: objAny = {
    "1": "primary",
    "2": "default",
    "3": ""
  };
  private loading = false;
  private total = 0;

  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("modelFile.fileName"),
      key: "fileName",
      minWidth: 120
    },
    {
      title: i18n.t("modelFile.pkid"),
      key: "pkid",
      minWidth: 120
    },
    {
      title: i18n.t("modelFile.createUserId"),
      key: "createUserId",
      minWidth: 100
    },
    {
      title: i18n.t("modelFile.createTime"),
      key: "createTime",
      minWidth: 160
    },
    {
      title: i18n.t("modelFile.attachmentPkId"),
      key: "attachmentPkId",
      minWidth: 120
    },
    {
      title: i18n.t("modelFile.modifyUserId"),
      key: "modifyUserId",
      minWidth: 100
    },
    {
      title: i18n.t("modelFile.modifyTime"),
      key: "modifyTime",
      minWidth: 160
    },
    {
      title: i18n.t("remark"),
      key: "remark",
      minWidth: 160
    },
    {
      title: i18n.t("operation"),
      key: "action",
      minWidth: 120,
      slot: "action"
    }
  ];
  public qyeryClick() {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public tableChange(val: number) {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getLModelFile(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  public addClick(): void {
    const addFile: objAny = this.$refs["addFile"];
    addFile.open();
  }

  public editClick(item: objAny) {
    const addFile: objAny = this.$refs["addFile"];
    addFile.open(item);
  }
  async delItemClick(item: objAny): Promise<void> {
    const ret = await getLModelFileDel({
      PkId: item.pkid
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }

  mounted() {
    this.privilegeVoObj = this.$route.meta.privilegeVoObj;
    this.getTableList();
  }
}
